import React, { type PropsWithChildren, type RefObject } from "react";
import clsx from "clsx";
import styles from "./SectionWrapper.module.scss";
import container from "../../../../../shared-components/css-modules/toyota/atoms/Container.module.scss";
import { useCarConfigSelector } from "../../../../redux/store";

export type SectionWrapperProps = {
    sectionId: string;
    sectionRef?: RefObject<HTMLElement>;
    wrap?: boolean;
};

const SectionWrapper: React.FC<PropsWithChildren<SectionWrapperProps>> = ({
    children,
    sectionRef,
    sectionId,
    wrap = true,
}) => {
    const sectionIsActive = useCarConfigSelector((state) => state.carConfigNavigation.activeSection === sectionId);
    const sectionIsPassed = useCarConfigSelector((state) =>
        (state.carConfigNavigation.passedSection as string[]).includes(sectionId),
    );

    return (
        <section
            id={sectionId}
            ref={sectionRef}
            className={clsx(
                styles[sectionId],
                styles["config-section"],
                sectionIsActive && styles.active,
                sectionIsPassed && styles.passed,
                !wrap && styles.full,
            )}
            data-section={sectionId}
        >
            <div className={wrap ? container.default : ""}>{children}</div>
        </section>
    );
};

export default SectionWrapper;
